App.TimeMachineComponent = Em.Component.extend
  classNames: [ 'time-machine' ]

  monitor: Em.inject.service('orderMonitor')

  currentTime: Em.computed.oneWay('monitor.globalTime')

  month: (->
    moment(@get('currentTime')).locale('en').format('MMM')
  ).property('currentTime')

  day: (->
    moment(@get('currentTime')).date()
  ).property('currentTime')

  year: (->
    moment(@get('currentTime')).year()
  ).property('currentTime')

  minute: (->
    moment(@get('currentTime')).minute()
  ).property('currentTime')

  hour: (->
    moment(@get('currentTime')).hour()
  ).property('currentTime')

  changeTime: (time) ->
    @get('monitor').set('globalTimeOverride', time)
    @get('monitor').notifyPropertyChange('globalTime')

  actions:
    plusFiveMinutes: ->
      @changeTime moment(@get('currentTime')).add(5, 'minutes').toDate()
      false

    plusThirtyMinutes: ->
      @changeTime moment(@get('currentTime')).add(30, 'minutes').toDate()
      false
    minusFiveMinutes: ->
      @changeTime moment(@get('currentTime')).subtract(5, 'minutes').toDate()
      false

    minusThirtyMinutes: ->
      @changeTime moment(@get('currentTime')).subtract(30, 'minutes').toDate()
      false